import { Form, Row, Upload } from "antd";
import { useCallback } from "react";
import { useDownload } from "../../../../../../../../../Administration/TemplatesTab/hooks/useDownload";
import { useUploadFile } from "../../../../../../../../../../lib/hooks/useUploadFile";
import { UserFilesService } from "../../../../../../../../../../services/userFiles";
import { useUploadFileRule } from "../../../../../../../../../../lib/hooks/useUploadFileRule";
import { UploadRow } from "../../../../../../../../../../components/EmailModal/components/UploadRow";

type AttachmentsProps = {
  clearError: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Attachments = ({ clearError, setIsLoading }: AttachmentsProps) => {
  const { isLoading, onDownload } = useDownload(UserFilesService);

  const onDownlaodClick = useCallback(
    (file: any) => !isLoading && onDownload(file.response, file.name),
    [onDownload, isLoading]
  );

  const { upload } = useUploadFile(2, setIsLoading);

  const { rule } = useUploadFileRule();

  return (
    <Row className="position-relative">
      <Form.Item
        label="Attachments"
        name="attachments"
        className="mb-2 w-100"
        valuePropName="fileList"
        getValueFromEvent={(e) => e.fileList}
        rules={rule}
      >
        <Upload
          listType="picture"
          customRequest={upload}
          previewFile={async () => ""}
          showUploadList={{ showDownloadIcon: true }}
          onDownload={onDownlaodClick}
          onRemove={clearError}
        >
          <UploadRow />
        </Upload>
      </Form.Item>
    </Row>
  );
};
